import { canv } from '@/canv/global.js'

export class shapeStoredData {

    constructor() {

    }

    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width * 3/4 - 2 * horizontalPadding;
        var allowedHeight = height - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width * 3/4 / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        var r = height / 30;
        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + width * 7/8, y);
        canv.ctx.lineTo(x + width/16, y);
        canv.ctx.ellipse(x + width/16, y + height/2, width/16, height/2, 0, 3/2 * Math.PI, Math.PI/2, true);
        canv.ctx.lineTo(x + width * 7/8, y + height);
        canv.ctx.ellipse(x + width * 7/8, y + height/2, width/8, height/2, 0, 1/2 * Math.PI, 3/2 * Math.PI);
    }

    getAvatar(color) {
        return `
        <svg width="95" height="80" viewBox="0 0 95 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 0H90C92.7615 0 95 2.23857 95 5C95 7.56475 93.069 9.6785 90.5812 9.9665C90.4842 10.0667 90.3453 10.2275 90.1665 10.476C89.4323 11.4967 88.5518 13.3317 87.7262 16.1425C86.0935 21.7017 85 29.9435 85 40C85 50.0565 86.0935 58.2982 87.7262 63.8575C88.5518 66.6683 89.4323 68.5033 90.1665 69.524C90.3453 69.7725 90.4842 69.9333 90.5812 70.0335C93.069 70.3215 95 72.4352 95 75C95 77.7615 92.7615 80 90 80H15C11.2683 80 8.64525 77.583 7.04855 75.3635C5.39005 73.0578 4.11563 70.0257 3.13158 66.6755C1.14518 59.9125 0 50.654 0 40C0 29.346 1.14518 20.0875 3.13158 13.3245C4.11563 9.974 5.39002 6.94225 7.04855 4.63662C8.64525 2.41687 11.2683 0 15 0Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` +  height + `" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.7797 2.12608L23.6757 2.13811L23.6708 2.13077L23.6743 2.13828L23.6741 2.1383C23.6706 2.13086 23.6706 2.13087 23.6706 2.13089L23.6703 2.131L23.6698 2.13123L23.6688 2.13169L23.6669 2.13261L23.663 2.13448L23.6552 2.13831L23.6499 2.1411L23.6021 2.14663L23.4778 2.27508C23.4329 2.32154 23.381 2.38305 23.3221 2.46487C23.0826 2.7978 22.8312 3.34059 22.6061 4.10713C22.1588 5.63027 21.8684 7.85 21.8684 10.5263C21.8684 13.2026 22.1588 15.4224 22.6061 16.9455C22.8312 17.712 23.0826 18.2548 23.3221 18.5878C23.381 18.6696 23.4329 18.7311 23.4778 18.7776L23.6021 18.906L23.6499 18.9115L23.6552 18.9143L23.663 18.9182L23.6669 18.92L23.6689 18.921L23.6698 18.9214L23.6703 18.9216L23.6706 18.9218C23.6706 18.9218 23.6706 18.9218 23.6741 18.9143L23.6743 18.9144L23.6708 18.9219L23.6757 18.9145L23.7797 18.9266C24.1851 18.9735 24.5 19.3187 24.5 19.7368C24.5 20.1874 24.1348 20.5526 23.6842 20.5526H3.94737C3.20234 20.5526 2.64268 20.0714 2.26079 19.5405C1.87052 18.998 1.55485 18.2599 1.30383 17.4053C0.798773 15.6857 0.5 13.3001 0.5 10.5263C0.5 7.75251 0.798773 5.36691 1.30383 3.64735L1.30384 3.64735C1.55485 2.79269 1.87051 2.05467 2.26078 1.51214L2.26078 1.51213C2.64266 0.981243 3.20232 0.5 3.94737 0.5H23.6842C24.1348 0.5 24.5 0.865236 24.5 1.31579C24.5 1.7339 24.1851 2.07915 23.7797 2.12608ZM23.5506 2.20911L23.5564 2.20415L23.6343 2.31743C23.5418 2.21704 23.5418 2.217 23.5418 2.21696L23.542 2.21683L23.5423 2.21658L23.5428 2.21608L23.5439 2.21507L23.5461 2.21307L23.5506 2.20911ZM23.5419 18.8357C23.5419 18.8357 23.5418 18.8356 23.6341 18.7355L23.5563 18.8485L23.5506 18.8436L23.5462 18.8396L23.544 18.8376L23.5429 18.8366L23.5423 18.8361L23.542 18.8358L23.5419 18.8357Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
